// extracted by mini-css-extract-plugin
export default {"sectionBio":"Bio_sectionBio__7JonK","BioText":"Bio_BioText__2t12N","BioHeading":"Bio_BioHeading__nMsLo","BioTextPara":"Bio_BioTextPara__HzSeZ"};